import { render, staticRenderFns } from "./orgDetailDialog.vue?vue&type=template&id=50f25481&scoped=true"
import script from "./orgDetailDialog.vue?vue&type=script&lang=js"
export * from "./orgDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./orgDetailDialog.vue?vue&type=style&index=0&id=50f25481&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f25481",
  null
  
)

export default component.exports